const baseurl = "https://www.onekbc.org";
// const baseurl = "http://localhost:8000";
export default baseurl;

